module.exports = __webpack_public_path__ + "media/38.536d5748.ogg";